import React, { useState, useEffect, useRef } from "react";
import Data from "../App";
import { of, BehaviorSubject, combineLatest } from "rxjs";
import {
  map,
  tap,
  switchMap,
  distinctUntilChanged,
  filter
} from "rxjs/operators";
import { List, Map, is, fromJS } from "immutable";
import CompView from "./CompView";
import CompJsonEdit from "./CompJsonEdit";

const UiViewComposition = ({ spec, expanded, editing, onChange }) => {
  function handleChildViewDelete(viewId) {
    console.log("handleChildViewDelete " + viewId);
  }
  function getChildComp(viewId) {
    return (
      <CompView
        key={viewId}
        compId={viewId}
        onDelete={() => handleChildViewDelete(viewId)}
      />
    );
  }
  function hasChildren() {
    return spec.get("childViews") && spec.get("childViews").size > 0;
  }
  const [selection, setSelection] = useState(hasChildren() ? 0 : -1);
  const [viewNames, setViewNames] = useState(null);

  function isInt(value) {
    return (
      !isNaN(value) &&
      (function(x) {
        return (x | 0) === x;
      })(parseFloat(value))
    );
  }

  function addNew() {
    console.log("addNew");
    let comp = new Map({
      type: "view",
      name: "tbd"
    });
    let newId = Data.getInstance().addComp(comp);
    addId(newId);
  }

  function addId(newId) {
    if (!spec.get("childViews")) {
      onChange(spec.set("childViews", new List([newId])));
    } else {
      onChange(spec.updateIn(["childViews"], list => list.push(newId)));
    }
  }

  const currentchildren = useRef(new BehaviorSubject());

  useEffect(() => {
    const sub = combineLatest(
      currentchildren.current.pipe(distinctUntilChanged()),
      Data.getInstance().getSpecs()
    )
      .pipe(
        map(arr => arr[0].map(childId => arr[1].get(childId).get("name"))),
        distinctUntilChanged()
      )
      .subscribe(names => {
        console.log("currentchildren " + names);
        setViewNames(names);
      });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  currentchildren.current.next(spec.get("childViews"));
  let childView;
  if (hasChildren()) childView = spec.get("childViews").get(selection);

  if (!viewNames) return "";
  let adding;
  if (editing) {
    adding = (
      <div>
        <div
          className="CompAddItem"
          onClick={e => {
            e.stopPropagation();
            addNew();
          }}
        >
          New Child
        </div>
        <CompJsonEdit
          json={JSON.stringify(spec.get("childViews"))}
          onSet={newObj => onChange(spec.set("childViews", newObj))}
          filterFct={item => isInt(item)}
        />
      </div>
    );
  }
  let specEdit = "";
  if (editing) {
    specEdit = (
      <div>
        <textarea
          value={spec.get("spec") ? spec.get("spec") : ""}
          onChange={e => onChange(spec.set("spec", e.target.value))}
        />
      </div>
    );
  }
  let specShow = "";
  if (expanded)
    specShow = (
      <div className="TextBox">{spec.get("spec") ? spec.get("spec") : ""}</div>
    );
  return (
    <div>
      <div className="ViewCompositionSelector">
        {spec.get("childViews").map((viewId, index) => (
          <div
            key={viewId}
            className={
              selection === index
                ? "ViewCompositionSelectorItem Selected"
                : "ViewCompositionSelectorItem"
            }
            onClick={e => {
              e.stopPropagation();
              setSelection(index);
            }}
          >
            {viewNames.get(index) ? viewNames.get(index) : "..."}
          </div>
        ))}
      </div>
      {adding}
      {specEdit}
      {specShow}
      {getChildComp(childView)}
    </div>
  );
};
export default UiViewComposition;



// WEBPACK FOOTER //
// ./src/components/UiViewComposition.js